const BROWSER_DEFAULT_ROOT_FONT_SIZE_PX = 16;

export default function readHostRootFontSize() {
    const rootFontSize = parseFloat(
        window.getComputedStyle(document.documentElement).fontSize,
    );

    return Number.isFinite(rootFontSize) && rootFontSize > 0
        ? rootFontSize
        : BROWSER_DEFAULT_ROOT_FONT_SIZE_PX;
}
